// extracted by mini-css-extract-plugin
export default {"divAnexo":"Anexos_divAnexo__lHrAz","anexo":"Anexos_anexo__JlFIG","file":"Anexos_file__rWQzZ"};